import * as z from "zod";

export const SUPERVISOR_GUIDANCE_MAX_LENGTH = 5000;

export const ShopperAgentSupervisorConfigSchema = z.object({
  guidance: z.string().trim().max(SUPERVISOR_GUIDANCE_MAX_LENGTH).optional(),
});

export type ShopperAgentSupervisorConfig = z.infer<
  typeof ShopperAgentSupervisorConfigSchema
>;
